import { MenuIcon } from "lucide-react";

export default function Header({ toggleCollapse, openMobile }) {
  return (
    <nav
      className="navbar shadow-sm sticky-top"
      style={{ backgroundColor: "#fff" }}
    >
      <button
        style={{ backgroundColor: "#6600cc" }}
        className="btn d-none d-lg-inline"
        onClick={toggleCollapse}
      >
        <MenuIcon color="#fff" />
      </button>
      <button
        className="btn d-lg-none"
        style={{ backgroundColor: "#6600cc" }}
        onClick={openMobile}
      >
        <MenuIcon color="#fff" />
      </button>
      <div className="ms-auto fw-semibold text-black">Admin</div>
    </nav>
  );
}
